import React from "react";
import '../css/photo.css';

import { useEffect } from "react";

export default function PhotoPopup(props) {

    const showDate = props.showDate

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                props.toggleOpen()
            }
        }

        document.addEventListener("keydown", handleKeyDown, false);
    
        return () => {
          document.removeEventListener("keydown", handleKeyDown, false);
        };
      }, [props]);

    return (

        <div className="overlay-bg" onClick={props.toggleOpen}>
            <div className="photo-popup max-width-1000">
                <h2>{props.data.title}</h2>
                <img className="popup-img" src={props.data.src} alt={props.data.title} />
                <div className="image-row">
                    <button className="button" onClick={props.prev}>&#10510;</button>
                    {showDate && <h3>Date created: {props.data.date}</h3>}
                    <button className="button" onClick={props.next}>&#10509;</button>
                </div>
            </div>
        </div>
    );
}
